<template>
  <section class="hero">
    <div class="hero__media">
      <video
        v-if="data.hero.video"
        :src="data.hero.video"
        autoplay
        muted
        loop
        playsinline
      />
      <img
        v-else
        :src="data.hero.image"
        alt=""
      >
      <div class="hero__overlay" />
    </div>

    <div class="hero__content container">
      <h1 class="hero__title">{{ data.hero.title }}</h1>
      <p class="hero__subtitle">{{ data.hero.subtitle }}</p>
      <div class="hero__ctas">
        <a
          class="btn-pill is-yellow-outline"
          :href="data.hero.ctaPrimary.href"
        >
          <BtnStar />
          {{ data.hero.ctaPrimary.label }}
        </a>
        <a
          class="btn-pill is-yellow-outline"
          :href="data.hero.ctaSecondary.href"
        >
          <BtnStar />
          {{ data.hero.ctaSecondary.label }}
        </a>
      </div>
    </div>

    <MarqueeBand
      class="hero__marquee"
      :items="data.hero.marquee"
      color="yellow"
    />
  </section>
</template>

<script>
import MarqueeBand from '@/components/MarqueeBand.vue'
import BtnStar from '@/components/BtnStar.vue'

export default {
  name: 'HeroSection',
  components: { MarqueeBand, BtnStar },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  min-height: 100svh;
  display: flex;
  align-items: flex-end;
  // pas d'overflow hidden : le bandeau chevauche la jonction avec la section suivante
}

.hero__media {
  position: absolute;
  inset: 0;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

// léger renfort de lisibilité sur la bichromie livrée
.hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba($navy, 0.35) 0%, rgba($navy, 0.05) 45%, rgba($navy, 0.35) 100%);
}

.hero__content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: $white;
  padding-bottom: clamp(110px, 16vh, 170px);

  // sur grand écran, remonter le bloc sous les épaules des personnes
  @media (min-width: 1500px) {
    padding-bottom: clamp(215px, 25vh, 310px);
  }
}

.hero__title {
  // le \n du contenu ne casse la ligne qu'en mobile
  font-size: clamp(42px, 6.4vw, 76px);
  font-weight: 800;
  letter-spacing: -0.005em;
  text-shadow: 0 2px 24px rgba(0, 0, 0, 0.25);
}

.hero__subtitle {
  white-space: pre-line;
  margin: 22px auto 0;
  max-width: 680px;
  font-size: clamp(17px, 2vw, 22px);
  line-height: 1.45;
  font-weight: 400;
}

.hero__ctas {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: clamp(36px, 4.5vw, 64px);
  margin-top: 44px;

  .btn-pill {
    padding: 10px 18px;
    font-size: 12px;
  }
}

// à cheval sur la jonction hero/campus : pas de trou de couleur
.hero__marquee {
  position: absolute;
  left: -2%;
  right: -2%;
  bottom: -20px;
  z-index: 2;
}

@include mobile {
  .hero__title {
    white-space: pre-line;
  }

  .hero__subtitle {
    white-space: normal;
  }

  .hero__ctas {
    gap: 14px;
  }

  .hero__marquee {
    bottom: -12px;
  }
}
</style>
